// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-list-item--disabled[data-v-46197bde]{background-color:#dedede}.closed-row[data-v-46197bde]{background-color:var(--v-error-lighten3)}.closed-row--disabled[data-v-46197bde]{background-color:var(--v-error-lighten4)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
